import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';

import { Container, MessagePopupWrapper } from './Styles';

interface BasicMessage {
  id: string;
  title: React.ReactNode | string;
  message?: React.ReactNode;
}

interface MessagePopupsListProps<Message extends BasicMessage> {
  transitionTime: number;
  position: 'top' | 'bottom';
  messages: Message[];
  children: (message: Message) => React.ReactNode;
}

const MessagePopupsList = <Message extends BasicMessage>({
  transitionTime,
  position,
  messages,
  children,
}: MessagePopupsListProps<Message>): ReturnType<React.FC<Message>> => (
  <TransitionGroup component={Container} $position={position}>
    {messages.map((message) => (
      <Transition
        key={message.id}
        timeout={transitionTime}
        // We need to reflow the styles for each child right after it gets
        // mounted, i.e. between states ENTER and ENTERING. CSSTransition does
        // the same under the hood.
        onEnter={(node: HTMLElement) => node.scrollTop}
      >
        {(state) => (
          <MessagePopupWrapper transitionState={state} transitionTime={transitionTime}>
            {children(message)}
          </MessagePopupWrapper>
        )}
      </Transition>
    ))}
  </TransitionGroup>
);

export default MessagePopupsList;
